<template>
    <div class="cp major-tab">
        <ul>
            <li
                v-for="(item, key) in tabList" :key="key"
                :class="[key === active? 'is-active': '']"    
            >
                <a @click.prevent="changeTab(key)">
                    {{ item.caption }}
                    <cpLabel
                        v-if="item.minorCaption !== undefined"
                        themes="danger"
                        :text="item.minorCaption"
                    ></cpLabel>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import cpLabel from '@/components/cpLabel'

    export default {
        components: {
            cpLabel,
        },
        props: {
            tabs: {
                require: true,
            },
            active: {
                require: true,
            },
        },
        computed: {
            tabList: function() {
                let $tabs = this.tabs;

                if( Array.isArray($tabs) ) {
                    let $result = {}

                    $tabs.forEach(item => {
                        $result[item] = item;
                    });

                    return $result;
                }else if( typeof $tabs === 'object' ) {
                    return $tabs;
                }else {
                    return {}
                }
            }
        },
        methods: {
            changeTab: function(tab){
                this.$emit('sendEvent', 'changeTab', tab);
            }
        },
    }
</script>

<style scoped lang="scss">

    .cp.major-tab::v-deep {
        border-bottom: $border;

        .g.pop-up & {
            margin-bottom: $interval-m;
        }

        @include media('mobile') {
            border-bottom: 0;
            margin-right: 0 !important;
        }

        ul {
            @extend %reset;
            padding: 0 $interval-xs;

            @include media('mobile') {
                padding: 0 $interval-m;
                white-space: nowrap;
                overflow-x: auto;
            }
        }

        li {
            position: relative;
            display: inline-block;
            vertical-align: bottom;
            margin: 0 $interval-xs;
            transition: $transition;

            @include media('mobile') {
                margin: $interval-xs;
                border-top: 0;
            }

            + li {
                margin-left: $interval-s;

                @include media('mobile') {
                    margin-left: $interval-xs;
                }
            }

            &.is-active {

                a {
                    color: $major-color;

                    &::before {
                        content: $content;
                    }
                }
            }
        }

        a {
            position: relative;
            display: block;
            padding: $interval-s $interval-m;
            border-radius: $border-radius $border-radius 0 0;
            transition: $transition;
            cursor: pointer;

            &::before {
                position: absolute;
                left: 0;
                right: 0;
                bottom: -1px;
                height: $interval-xs;
                background-color: $major-color;
            }

            @include media('mobile') {
                // border-radius: $border-radius;
            }

            @include media('pad') {
                padding: $interval-s $interval-l;
            }

            @include media('phone') {
                padding: $interval-s;
            }

            &:hover {
                background-color: $light-gray;
            }
        }
    }
</style>
